const opt = (label:string) => ({label, value: label});

export const countries = [
    {label: 'United States', value: 'US'},
    {label: 'Canada', value: 'CA'},
    {label: 'Mexico', value: 'MX'},
];

export const relationshipRoles = [
    opt('Owner'),
    opt('Manager'),
    opt('Staff'),
];

export const designations = [
    {label: 'Contributing', value: 'Contributing'},
    {label: 'Non-contributing', value: 'Non-contributing'},
    {label: 'Significant', value: 'Significant'},
];

export const userRoles = [
    {label: 'Admin', value: 1},
    {label: 'Volunteer', value: 2},
    {label: 'Committee Member', value: 3},
    {label: 'Committee Chair', value: 4},
    {label: 'Board Member', value: 5},
    {label: 'Executive Committee/Staff', value: 6},
];

export const donationTypes = [
    opt('Single'),
    opt('Recurring'),
    opt('In Kind'),
];

export const donationFrequencies = [
    opt('Monthly'),
    opt('Quarterly'),
    opt('Yearly'),
];

export const emailNotificationTypes = [
    {label: 'Custom Notifications', value: 'all'},
    {label: 'Daily Summary', value: 'daily_summary'},
    {label: 'None (Disable Notifications)', value: 'none'},
];
